"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FlagFindSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13,9 C14.6568542,9 16,10.3431458 16,12 C16,12.6478836 15.7946246,13.2477991 15.4454251,13.7381953 L16.8535534,15.1464466 C17.0488155,15.3417088 17.0488155,15.6582912 16.8535534,15.8535534 C16.679987,16.0271197 16.4105626,16.0464049 16.2156945,15.9114088 L16.1464466,15.8535534 L14.7381953,14.4454251 C14.2477991,14.7946246 13.6478836,15 13,15 C11.3431458,15 10,13.6568542 10,12 C10,10.3431458 11.3431458,9 13,9 Z M13.5,4 C13.7761424,4 14,4.22385763 14,4.5 C14,4.60848656 13.9654492,4.70890335 13.9067512,4.79084693 L12.1009252,7.5 L12.458465,8.03634709 C12.1031276,8.08443941 11.7626057,8.17919213 11.443271,8.31423347 L10.8990748,7.5 L12.5657415,5 L6,5 L6,10 L9.53577067,9.99889078 C9.35637963,10.3087751 9.21737479,10.6449588 9.12595483,11.0002435 L6,11 L6,15 L5,15 L5,4 L13.5,4 Z M13,10 C11.8954305,10 11,10.8954305 11,12 C11,13.1045695 11.8954305,14 13,14 C14.1045695,14 15,13.1045695 15,12 C15,10.8954305 14.1045695,10 13,10 Z" })));
};
FlagFindSmall.displayName = 'FlagFindSmall';
exports.default = FlagFindSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FlagFindSmall.js.map